module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/inverted_triangle-937661b8e18ad95dd0ef604dbdbaf23d.svg";